import { render, staticRenderFns } from "./BaseTemplate.vue?vue&type=template&id=7b11a2e8&"
import script from "./BaseTemplate.vue?vue&type=script&lang=ts&"
export * from "./BaseTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports